module.exports = __webpack_public_path__ + "static/media/orderDetailsStatusIcon.c8faa182.svg";